const whiteList = {
  com: ['ArrowLeft', 'ArrowRight', 'Backspace', 'Tab', 'Delete', 'Home', 'End'],
  num: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
}

export default {
  init(app) {
    app.directive('num', (el, binding, vnode, prevNode) => {
      let $input = null
      if(!el['isNum']) {
        el['isNum'] = true
        if(el.tagName === 'INPUT') {
          $input = el
        } else {
          $input = el.getElementsByTagName('input')[0]
        }
        $input.addEventListener('keydown', (e) => {
          let {target, key, ctrlKey} = e
          if(ctrlKey || [...whiteList.com, ...whiteList.num].indexOf(key) >= 0) {
            return true
          }
          if(binding.value && key === '.' && target.value.indexOf('.') === -1) {
            return true
          }
          return false
        })
        $input.addEventListener('input', (e) => {
          let len = binding.value || 0
          let {value} = e.target
          if(len) {
            e.target.value = value.replace(/[^\d\.]/g, '').replace(new RegExp(`(^\\d*\\.\\d{0,${len}}).+`), '$1')
          } else {
            e.target.value = value.replace(/\D/g, '')
          }
          if(e.target.value !== value) {
            vnode.componentInstance && vnode.comnponentInstance.handleInput(e)
          }
        })
        $input.addEventListener('paste', (e) => false)
      }
    })
    app.directive('msg', (el, binding, vnode, prevNode) => {
      if(!el.initial && (!binding.value || !binding.value.showMsg)) {
        el.initial = true
        const config = { attributes: true, childList: true, subtree: true }
        const callback = (e) => {
          let $errors = el.getElementsByClassName('el-form-item__error')
          if($errors.length) {
            if($errors[0].textContent.replace(/\s/g, '') === '') {
              $errors[0].style.display = 'none'
            } else {
              $errors[0].style.display = 'inline'
            }
          }
        }
        const observer = new MutationObserver(callback)
        observer.observe(el, config)
      }
    })
    app.directive('number-decimal', (el, binding, vnode, prevNode) => {
      if (!el.initial && binding.value !== undefined) {
        el.initial = true
        const NumberDecimal = binding.value
        if (typeof NumberDecimal === 'number') {
          el.onkeydown = (e) => {
            const selection = window.getSelection()
            const value = el.innerText.replace(/[^\d\.]/g, '')
            // 避免重复输入小数点
            if (e.key === '.' && (NumberDecimal === 0 || /\./.test(el.innerText))) return false
            // 输入数字，已满足n位小数，光标在小数点后
            const isNumKey = /^\d$/.test(e.key)
            const decimalReady = new RegExp(`\\.\\d{${NumberDecimal}}`).test(value)
            const offsetReady = selection.anchorOffset === selection.focusOffset && selection.anchorOffset > value.length - NumberDecimal - 1
            if (isNumKey && decimalReady && offsetReady) return false
            return /^ArrowLeft|ArrowRight|Backspace|[1234567890.]$/.test(e.key)
          }
          el.onblur = () => {
            const value = el.innerText.replace(/[^\d\.]/g, '')
            if (NumberDecimal <= 0) {
              el.innerText = value.replace(/\./g, '')
            } else {
              el.innerText = value.replace(new RegExp(`(\\.\\d{${NumberDecimal}}).*$`), '$1')
            }
            vnode.ref.i.ctx.onInput()
          }
        }
      }
    })
  }
}

// el.addEventListener('DOMSubtreeModified', (e) => {
//   let $errors = el.getElementsByClassName('el-form-item__error')
//   if($errors.length) {
//     if($errors[0].textContent.replace(/\s/g, '') === '') {
//       $errors[0].style.display = 'none'
//     } else {
//       $errors[0].style.display = 'inline'
//     }
//   }
// })